module.exports = __webpack_public_path__ + "static/media/videoImage.35fb0533.png";